// extracted by mini-css-extract-plugin
module.exports = {"container":"container--PostToSmartList-routes__3LMtn"};